<template>
  <div id="app">

    <div class="head-view">
      <span>久草碧碧</span>
      <span class="flag">影视永久发布页</span>
    </div>

    <div class="field">
      <div class="nav-view">
        <a class="btn" href="https://9cbb.ggff.net/">临时地址一</a>
        <a class="btn" href="https://9cbb.ggff.net/">临时地址二</a>
        <a class="btn" href="https://9cbb.ggff.net/">临时地址三</a>
        <a class="btn" href="https://9cbb.ggff.net/">临时地址四</a>
        <a class="btn" href="https://9cbb.ggff.net/">临时地址五</a>
        <a class="btn" href="https://9cbb.ggff.net/">临时地址六</a>
        <a class="btn" href="https://9cbb.ggff.net/">临时地址七</a>
        <a class="btn" href="https://9cbb.ggff.net/">临时地址八</a>
        <a class="btn" href="https://9cbb.ggff.net/">临时地址九</a>
      </div>
      <span class="title">线路网址不定期更新，请收藏，避免遗失本站。</span>
      <span class="warn">部分浏览器可能会屏蔽本站</span>
      <span class="warn">请每次浏览都先打开此页，再点击上面地址进入</span>
      <span class="warn">以确保每次都能正常浏览</span>
    </div>

    <div class="field ">
      <div class="item-view">
          <span style="color: #16d620">广告联系 :</span>
          <a href="https://t.me/jiucbb">
            <span style="color:#0509f9"> @jiucbb</span>
          </a> 
      </div>
      <div class="item-view">
          <span>发送任意内容到邮箱获取新地址</span><span> 917cbb@gmail.com</span>
      </div>
      <div class="item-view">
          <span class="title">以下为发布页永久网址，请收藏到浏览器</span><span class="title">【 9cbb.top 】</span>
      </div>
    </div>

    <div class="field ">
      <div class="tips-view">
        <span>✐ 溫馨提示</span>
        <span>* 推荐使用谷歌(Chrome)浏览器访问本站，谷歌浏览器速度更快，iPhone建议使用手机自带Safria浏览器访问</span>
        <span>* 一定要收藏此页，本站经常会换域名，收藏并分享才是好狼友。</span>        
      </div>
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {
    
    }
  },
  created () {
   


  },
  mounted () {
    
  },
  methods: {
 
  }
}
</script>

<style lang="less">
  body {
    background-color: #f90505;
    font-size: 15px;
  }
  * {
    box-sizing: border-box;
  }
  a {
    // color: #f90505;
    text-decoration-line: none;
  }
#app {
    margin: 10px auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .head-view {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      text-align: center;
      color: #16d620;
      font-size: 30px;
      font-weight: 200;
      padding: 20px;
      cursor: pointer;
      font-weight: 700;
        .flag {
          color: #FA3853;
          background: #fff;
          border-radius: 5px;
          font-size: 15px;
          font-weight: 700;
          display: inline-block;
          padding: 0 5px;
          margin-left: 5px;         
        }
    }

    .field {
      width: 500px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #fff;
      color: #6c757d;
      font-size: 15px;
      padding: 15px;
      margin-bottom: 5px;
      border-radius: 5px;
      border: 3px solid #c0330b;
      gap: 10px;
      .nav-view{
        display:flex;flex-wrap:wrap;justify-content:center;align-items:center;margin-bottom: 20px;
        .btn{width:25%;max-width:170px;height:45px;line-height:45px;text-align:center;margin:7.5px 9px;box-shadow:5px 5px 0 0 #f44336;border-radius:5px;background:rgba(234,175,82,0.3);color:#d21515;font-size:.9375em;cursor:pointer;position:relative}
        .btn:hover{background:#ff6ea1;color:#fff}
      }
      .title {
        font-size: 15px;
        // margin-bottom: 10px;
        font-weight: 700;
        color: #6c757d;
      }
      .warn {
        // margin-bottom: 12px;
        font-weight: 700;
        color: #da634b;
      }


      .item-view {
        // margin-bottom: 14px;
        text-align: center;
        span {
          &:last-child {
            color: #da634b;
          }
        }
        &:last-child {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }


      .tips-view {
        padding: 5px;
        font-size: 14px;
        & :first-child{
          font-size: 16px;
          font-weight: 700;
          text-align: center;
          // font-size: 15px;
        }
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 10px;
        // text-align: center;
      }

    }
  }
    @media (max-width: 500px) {
    #app {
        padding: 0 5px;
        .field {
            width: 100%;
            padding: 15px 0
        }
    }
  }
  
  
</style>